import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

export default function UserDevices() {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:4000";
  // Obtener el usuario del store de Redux
  const user = useSelector((state) => state.auth.user);
  const isAdmin = user?.role === "admin";

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${apiUrl}/api/v1/userDevices`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDevices(res.data);
      } catch (err) {
        console.error("Error al cargar dispositivos:", err);
        setError("No se pudieron cargar los dispositivos");
      } finally {
        setLoading(false);
      }
    };

    fetchDevices();
  }, []);

  const handleDelete = async (id) => {
    // Solo los administradores pueden eliminar dispositivos
    if (!isAdmin) {
      setError("No tienes permisos para eliminar dispositivos. Contacta a soporte si necesitas gestionar tus dispositivos.");
      return;
    }
    
    const confirmDelete = window.confirm("¿Eliminar este dispositivo?");
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${apiUrl}/api/v1/userDevices/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDevices((prev) => prev.filter((d) => d.deviceId !== id));
      setError(null);
    } catch (err) {
      console.error("Error al eliminar dispositivo:", err);
      if (err.response?.status === 403) {
        setError("No tienes permisos para eliminar dispositivos. Contacta a soporte si necesitas gestionar tus dispositivos.");
      } else {
        setError("Error al eliminar el dispositivo");
      }
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Mis Dispositivos Conectados</h3>
      
      {error && (
        <div className="bg-red-900/50 border border-red-700 text-white px-4 py-2 rounded-md mb-4">
          {error}
        </div>
      )}
      
      {loading ? (
        <p className="text-gray-400">Cargando dispositivos...</p>
      ) : devices.length === 0 ? (
        <div className="bg-gray-800 rounded-lg p-4">
          <p className="text-gray-400">No tienes dispositivos registrados.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {devices.map((device) => (
            <div key={device.id} className="bg-gray-800 rounded-lg p-4">
              <div className="flex justify-between items-center mb-2">
                <span className="font-semibold">{device.deviceName || "Desconocido"}</span>
                {isAdmin && (
                  <button
                    onClick={() => handleDelete(device.deviceId)}
                    className="bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700"
                  >
                    Eliminar
                  </button>
                )}
              </div>
              <div className="grid grid-cols-2 gap-2 text-sm">
                <div className="text-gray-400">Último acceso:</div>
                <div>{device.lastAccess ? new Date(device.lastAccess).toLocaleString() : "No disponible"}</div>
                <div className="text-gray-400">IP:</div>
                <div>{device.ipAddress}</div>
                <div className="text-gray-400">Registrado:</div>
                <div>{new Date(device.createdAt).toLocaleString()}</div>
              </div>
              {!isAdmin && (
                <div className="mt-3 text-sm text-amber-500 border-t border-gray-700 pt-2">
                  Si necesitas gestionar tus dispositivos, contacta a soporte.
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
